import { z } from "zod";

import { auditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const moveInMoveOutHeatSchema = z.object({
  auditDate: auditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  heatThermostat: environmentalChecklistItemWithTicket,
  heatFurnace: environmentalChecklistItemWithTicket,
  heatFilter: environmentalChecklistItemWithTicket,
  heatWaterHeater: environmentalChecklistItemWithTicket,
});
